import React, { PropsWithChildren } from 'react';
import { Box, Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

export type TooltipProps = {
  inline?: boolean;
} & MuiTooltipProps;

const Tooltip = ({ inline, children, ...tooltipProps }: PropsWithChildren<TooltipProps>) => {
  return tooltipProps.title ? (
    <MuiTooltip {...tooltipProps}>
      <Box component={inline ? 'span' : 'div'}>{children}</Box>
    </MuiTooltip>
  ) : (
    <>{children}</>
  );
};

export { Tooltip };
